import { RouteObject } from "react-router-dom";
import MenuLayout from "../MenuLayout";
import SessionBoundary from "../SessionBoundary";
import ValidateUUID from "../ValidateUUID";
import MessageCenterScreen from "./MessageCenterScreen";

// A single route with an optional connectionId keeps MessageCenterScreen
// mounted when /messages redirects to /messages/:connectionId, so navigating
// to Messages doesn't remount the screen and refetch its queries.
const MessagesRoutes: RouteObject = {
  path: "/messages/:connectionId?",
  element: (
    <SessionBoundary>
      <MenuLayout currentTab="messages">
        <ValidateUUID id="connectionId" optional>
          <MessageCenterScreen />
        </ValidateUUID>
      </MenuLayout>
    </SessionBoundary>
  ),
};

export default MessagesRoutes;
